export default "__VITE_ASSET__CN3gqhob__"